import { PopupPageId, ProvincesShortCode, TabNames } from "./Components/navigationTypes";
import { store } from "./redux/store";

const getProvScreen: (appCode: string) => ScreenType = (appCode) => {
    let screen: ScreenType;
    switch (appCode) {
        case "BC":
            screen = BCScreen;
            break;
        case "NS":
        case "MB":
        case "AB":
        case "SK":
            screen = SKScreen;
            break;
        case "ON":
        default:
            screen = ONScreen;
            break;
    }
    return screen;
}
export class ScreenController {
    screen: ScreenType;
    window: Window;
    frame: Document;
    appCode: ProvincesShortCode;

    constructor(window: Window) {
        const appCode = store?.getState()?.SessionInfo?.appProvinceShort;
        const screen: ScreenType = getProvScreen(appCode);
        this.screen = screen;
        this.window = window;
        this.frame = window.document;
        this.appCode = appCode;
    }

    getPosition(): { tabName: TabNames | PopupPageId, tabNumber: number } {
        if (this.frame.getElementById(this.screen.contentId).style.display === 'none') {
            return this.getNewScreen()
        }
        const mainTabs: Element = this.frame.getElementsByClassName(this.screen.MenuItems.containerClass)[0];
        const mainTabElmt: Element = mainTabs.getElementsByClassName(this.screen.MenuItems.onOffControl.onClass)[0];
        const possibleTabs = this.screen.MenuItems.menus;
        const mainTab = possibleTabs.find((tab) => mainTabElmt.getAttribute('id') === tab.id)
        const mainTabName: TabNames = mainTab.name

        const subTabs: Array<Element> = Array.from(this.frame.getElementById(mainTab.menuItems.onOffControl.elementID).getElementsByClassName(mainTab.subMenuClass));
        const subTabIndex = subTabs.findIndex((tab) => tab.classList.contains(mainTab.menuItems.onOffControl.onClass))
        return { tabName: mainTabName, tabNumber: subTabIndex }
    }
    getNewScreen(): { tabName: PopupPageId, tabNumber: number } {
        let funcs: any = this.window
        return {
            tabName: funcs.documentExport.getActiveSection().id,
            tabNumber: funcs.documentExport.getActivePosition(),
        }
    }
    private setTab(tabName: TabNames, tabNumber: number): void {
        this.setNewScreen(PopupPageId.None);
        const setMenu = this.screen.MenuItems.menus.find(menuItem => menuItem.name === tabName)
        const setMenuItems = setMenu.menuItems;

        //Click highest tab
        this.frame.getElementById(setMenu.id).click();
        // Unhide combo div
        this.frame.getElementById(this.screen.contentId).style.display = '';

        // Check sub tabs
        if (setMenuItems && (setMenuItems.loop || setMenuItems.menus)) {
            const tabContainer: HTMLElement = this.frame.getElementById(setMenuItems.onOffControl.elementID);
            if (!tabContainer) {
                throw new Error("No Tab containers");
            }
            //tabContainer.style.display = 'none'
            const subMenuClass = '.' + setMenu.subMenuClass;
            // For some reason querySelectorAll<HTMLElement> returns empty list, so cast tabs into htmlelement
            const tabSelection = tabContainer.querySelectorAll(subMenuClass);
            const tabs: any[] = Array.from(tabSelection);
            if (tabNumber === -1) {
                setTimeout(() => {
                    const tabSelection = tabContainer.querySelectorAll(subMenuClass);
                    const tabs: any[] = Array.from(tabSelection);
                    const tabNumber = tabSelection.length - 1;
                    tabs[tabNumber].click()
                }, 10)
            } else if (setMenuItems.loop) {
                setTimeout(() => {
                    const tabSelection = tabContainer.querySelectorAll(subMenuClass);
                    const tabs: any[] = Array.from(tabSelection);
                    const clickTab = tabs.find(tab => tab.getAttribute('loopcount') === String(tabNumber))
                    console.assert(clickTab, `Menu tabs are defined incorrectly" ${tabName}: ${tabNumber}`);
                    if(clickTab){
                        clickTab.click();
                    }
                }, 10)

            } else {
                setTimeout(() => {
                    const validTab = (tabs.length > tabNumber) 
                    console.assert(validTab, `Menu tabs are defined incorrectly" ${tabName}: ${tabNumber}`);
                    if(validTab){
                        tabs[tabNumber].click()
                    } else {
                        tabs[0].click();
                    }
                }, 10)
            }
        }
    }

    // Hide old screens before setting new screens
    protected setNewScreen(page: PopupPageId, tabNumber?: number): void {
        // hide combo div
        try {
            this.frame.getElementById(this.screen.contentId).style.display = 'none';
        } catch (e) {
            console.log(`display fail ${this.screen.contentId}`)
        }
        this.openNewScreen(page, tabNumber)
    }

    private openNewScreen(page: PopupPageId, tabNumber?: number): void {
        let funcs: any = this.window
        funcs.documentExport.activeSection(page, tabNumber)
    }
    private setBasicTab(tabNumber: number): void {
        this.setTab("Basic", tabNumber);
    }
    private setIssuesTab(tabNumber: number): void {
        this.setTab("Issues", tabNumber);
    }
    private setMortgagesTab(tabNumber: number): void {
        this.setTab("Mortgages", tabNumber);
        this.openNewScreen(PopupPageId.MortgageID, tabNumber);
    }
    private setTitleInsTab(): void {
        this.setTab("Title Insurance", -1);
    }
    private setFireInsuranceTab(): void {
        this.setTab("Fire Insurance", -1);
    }
    private setFinancialTab(tabNumber: number): void {
        this.setTab("Financial", tabNumber);
    }
    private setDocTab(tabNumber: number): void {
        this.setTab("Documents", tabNumber);
    }

    newTabFromName(tabName: TabNames | PopupPageId): void {
        switch (tabName) {
            case "Basic":
                this.setBasicTab(-1);
                break;
            case "Issues":
                this.setIssuesTab(-1);
                break;
            case "Mortgages":
                this.setMortgagesTab(-1);
                break;
            case "Title Insurance":
                this.setTitleInsTab();
                break;
            case "Fire Insurance":
                this.setFireInsuranceTab();
                break;
            case "Financial":
                return this.setFinancialTab(-1);
            case "Documents":
                return this.setDocTab(-1);
            case PopupPageId.None:
            case PopupPageId.Transferee:
            case PopupPageId.Transferor:
            case PopupPageId.Solicitor:
            case PopupPageId.VendorSolicitor:
            case PopupPageId.InsuranceAgent:
            case PopupPageId.MortgageBroker:
            case PopupPageId.Conveyancer:
            case PopupPageId.RealEstateAgent:
            case PopupPageId.MortgageID:
            case PopupPageId.PurchaserRealEstateAgent:
            case PopupPageId.OtherParty:
                return this.setNewScreen(tabName, -1);
            default:
                break;
        }
    }
    setTabFromName(tabName: TabNames | PopupPageId, tabNumber?: number): void {
        switch (tabName) {
            case "Basic":
                this.setBasicTab(tabNumber);
                break;
            case "Issues":
                this.setIssuesTab(tabNumber);
                break;
            case "Mortgages":
                this.setMortgagesTab(tabNumber);
                break;
            case "Title Insurance":
                this.setTitleInsTab();
                break;
            case "Fire Insurance":
                this.setFireInsuranceTab();
                break;
            case "Financial":
                return this.setFinancialTab(tabNumber);
            case "Documents":
                return this.setDocTab(tabNumber);
            case "Registrations":
                return this.setTab('Registrations', tabNumber);
            case PopupPageId.None:
            case PopupPageId.Transferee:
            case PopupPageId.Transferor:
            case PopupPageId.Solicitor:
            case PopupPageId.VendorSolicitor:
            case PopupPageId.InsuranceAgent:
            case PopupPageId.MortgageBroker:
            case PopupPageId.Conveyancer:
            case PopupPageId.RealEstateAgent:
            case PopupPageId.MortgageID:
            case PopupPageId.PurchaserRealEstateAgent:
            case PopupPageId.OtherParty:
                return this.setNewScreen(tabName, tabNumber);
            default:
                break;
        }
    }
}

export type ScreenType = {
    headingClass: string,
    contentId: string,
    stickerId: string,
    MenuItems: {
        containerClass: string,
        onOffControl: { onClass: string, offClass: string },
        menus: Array<{
            name: TabNames,
            id: string,
            subMenuClass?: string,
            menuItems?: {
                container?: string,
                onOffControl: {
                    elementID: string,
                    attribute: string,
                    onClass: string,
                }
                loop?: boolean,
                menus?: Array<{ name: string }>
            },
        }>
    }
    NewScreen: Array<{
        id: string,
        xmlbaseControl: string,
    }>
}

export function getSubTabName(appCode: string, mainTabName: TabNames, subTabIndex: number): string {
    const screen = getProvScreen(appCode);
    const mainTab = screen.MenuItems.menus.find((tab) => { return tab.name === mainTabName });
    const subTabs = mainTab?.menuItems?.menus;
    if (subTabs && subTabIndex < subTabs.length) {
        return subTabs[subTabIndex].name;
    }
}

export const ONScreen: ScreenType = {
    headingClass: "file-header", // keep on allways
    contentId: "comboDiv",  // off only new screen is on
    stickerId: "stickers",  // off only new screen is on
    MenuItems: {  // main menu
        containerClass: "main-tabs",  // style height:0px
        onOffControl: { onClass: "tabhi", offClass: "tablo" }, // for status detection
        menus: [
            {
                name: "Basic", id: "headingTabBasic",  // use id to find item use onclick to trigger on, others will be off with onclicj function
                subMenuClass: "sub-tab",  // style height:0px, it is inside comboDiv
                menuItems: {
                    container: "basicTab", onOffControl: {  // container id
                        elementID: "BasicNum",   // use it to set which sub tab is on/off using #
                        attribute: "BasicNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [    // list of tab may not be needed because the number can control each item, unless use it to map new left screen
                        { name: "Basic" },
                        { name: "Property" },
                        { name: "Contract" },
                        { name: "Title" },
                        { name: "Writ" },
                    ]
                }
            },
            {
                name: "Issues", id: "headingTabDul",
                subMenuClass: "sub-tab",  // height 0
                menuItems: {
                    onOffControl: {
                        elementID: "IssueTabNum",
                        attribute: "tabNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "Master" },
                        { name: "Inquiry" },
                        { name: "Requsition" },
                        { name: "Checklist" },
                        { name: "Title" },
                    ]
                }
            },
            {
                name: "Mortgages", id: "headingTabMort",
                subMenuClass: "sub-tab",
                menuItems: {
                    loop: true,  // loop item so only need to know mortgage #
                    onOffControl: {
                        elementID: "MortTabNum",
                        attribute: "tabNum",
                        onClass: "sub-tab-active",
                    },
                }
            },
            {
                name: "Title Insurance", id: "headingTabTplus",  // no sub menu
            },
            {
                name: "Fire Insurance", id: "headingTabFireInsurance",  // no sub menu
            },
            {
                name: "Financial", id: "headingTabAcct",
                subMenuClass: "sub-tab",
                menuItems: {
                    onOffControl: {
                        elementID: "AcctNum",
                        attribute: "AcctNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "Adjustments" },
                        { name: "Land Transfer Tax" },
                        { name: "Account to Client" },
                        { name: "Trust Statement" },
                        { name: "Closing Funds Summary" },
                        { name: "Account to Client - Interim" },
                    ]
                }
            },
            {
                name: "Documents", id: "headingTabDoc",
            },
        ]
    },
    NewScreen: [
        {
            id: "newFrameBuyerLiveForm", xmlbaseControl: "loop"
        },
        {
            id: "newFrameSellerLiveForm", xmlbaseControl: "loop"
        },
        {
            id: "newFrameSolicitorLiveForm", xmlbaseControl: "",  // already set base properly inside liveform
        }
    ]
}


export const SKScreen: ScreenType = {
    headingClass: "file-header", // keep on allways
    contentId: "comboDiv",  // off only new screen is on
    stickerId: "stickers",  // off only new screen is on
    MenuItems: {  // main menu
        containerClass: "main-tabs",  // style height:0px
        onOffControl: { onClass: "tabhi", offClass: "tablo" }, // for status detection
        menus: [
            {
                name: "Basic", id: "headingTabBasic",  // use id to find item use onclick to trigger on, others will be off with onclicj function
                subMenuClass: "sub-tab",  // style height:0px, it is inside comboDiv
                menuItems: {
                    container: "basicTab", onOffControl: {  // container id
                        elementID: "BasicNum",   // use it to set which sub tab is on/off using #
                        attribute: "BasicNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [    // list of tab may not be needed because the number can control each item, unless use it to map new left screen
                        { name: "Basic" },
                        { name: "Property" },
                        { name: "Contract" },
                        { name: "Title" },
                        { name: "Writ" },
                    ]
                }
            },
            {
                name: "Issues", id: "headingTabDul",
                subMenuClass: "sub-tab",  // height 0
                menuItems: {
                    onOffControl: {
                        elementID: "IssueTabNum",
                        attribute: "tabNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "Master" },
                        { name: "Inquiry" },
                        { name: "Requsition" },
                        { name: "Checklist" },
                        { name: "Title" },
                    ]
                }
            },
            {
                name: "Mortgages", id: "headingTabMort",
                subMenuClass: "sub-tab",
                menuItems: {
                    loop: true,  // loop item so only need to know mortgage #
                    onOffControl: {
                        elementID: "MortTabNum",
                        attribute: "tabNum",
                        onClass: "sub-tab-active",
                    },
                }
            },
            {
                name: "Title Insurance", id: "headingTabTP",  // no sub menu
            },
            {
                name: "Fire Insurance", id: "headingTabFireInsurance",  // no sub menu
            },
            {
                name: "Financial", id: "headingTabAcct",
                subMenuClass: "sub-tab",
                menuItems: {
                    onOffControl: {
                        elementID: "AcctNum",
                        attribute: "AcctNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "Adjustments" },
                        { name: "Land Transfer Tax" },
                        { name: "Account to Client" },
                        { name: "Trust Statement" },
                        { name: "Closing Funds Summary" },
                    ]
                }
            },
            {
                name: "Documents", id: "headingTabDoc",
            },
        ]
    },
    NewScreen: [
        {
            id: "newFrameBuyerLiveForm", xmlbaseControl: "loop"
        },
        {
            id: "newFrameSellerLiveForm", xmlbaseControl: "loop"
        },
        {
            id: "newFrameSolicitorLiveForm", xmlbaseControl: "",  // already set base properly inside liveform
        }
    ]
}

const BCScreen: ScreenType = {
    headingClass: "file-header", // keep on allways
    contentId: "comboDiv",  // off only new screen is on
    stickerId: "stickers",  // off only new screen is on
    MenuItems: {  // main menu
        containerClass: "main-tabs",  // style height:0px
        onOffControl: { onClass: "tabhi", offClass: "tablo" }, // for status detection
        menus: [
            {
                name: "Basic", id: "headingTabBasic",  // use id to find item use onclick to trigger on, others will be off with onclicj function
                subMenuClass: "sub-tab",  // style height:0px, it is inside comboDiv
                menuItems: {
                    container: "basicTab", onOffControl: {  // container id
                        elementID: "BasicNum",   // use it to set which sub tab is on/off using #
                        attribute: "BasicNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [    // list of tab may not be needed because the number can control each item, unless use it to map new left screen
                        { name: "Basic" },
                        { name: "Property" },
                        { name: "Contract" },
                    ]
                }
            },
            {
                name: "Issues", id: "headingTabDul",
                subMenuClass: "sub-tab",  // height 0
                menuItems: {
                    onOffControl: {
                        elementID: "IssueTabNum",
                        attribute: "tabNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "Issues List" },
                        { name: "Undertaking Letter" },
                        { name: "Checklist" },
                        { name: "Inquiry" },
                        { name: "Report" },
                    ]
                }
            },
            {
                name: "Mortgages", id: "headingTabMort",
                subMenuClass: "sub-tab",
                menuItems: {
                    loop: true,  // loop item so only need to know mortgage #
                    onOffControl: {
                        elementID: "MortTabNum",
                        attribute: "tabNum",
                        onClass: "sub-tab-active",
                    },
                }
            },
            {
                name: "Title Insurance", id: "headingTabTP",  // no sub menu
            },
            {
                name: "Fire Insurance", id: "headingTabFireInsurance",  // no sub menu
            },
            {
                name: "Financial", id: "headingTabAcct",
                subMenuClass: "sub-tab",
                menuItems: {
                    onOffControl: {
                        elementID: "AcctNum",
                        attribute: "AcctNum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "Vendor Adjustments" },
                        { name: "Purchaser Adjustments" },
                        { name: "Trust Statement" },
                        { name: "Account to Client" },
                    ]
                }
            },
            {
                name: "Registrations", id: "headingTabReg",
                subMenuClass: "sub-tab",
                menuItems: {
                    onOffControl: {
                        elementID: "LTSANum",
                        attribute: "LTSANum",
                        onClass: "sub-tab-active",
                    },
                    menus: [
                        { name: "LOTR" },
                        { name: "Web Filing" },
                    ]
                }
            },
            {
                name: "Documents", id: "headingTabDoc",
            },
        ]
    },
    NewScreen: [
        {
            id: "newFrameBuyerLiveForm", xmlbaseControl: "loop"
        },
        {
            id: "newFrameSellerLiveForm", xmlbaseControl: "loop"
        },
        {
            id: "newFrameSolicitorLiveForm", xmlbaseControl: "",  // already set base properly inside liveform
        }
    ]
}